module.exports = __webpack_public_path__ + "img/mobile_menu_icon.ef0f5575.svg";